import gsap from 'gsap'

window.addEventListener('load', () => {
  const mainLoader = document.querySelector('.main-load')
  if (mainLoader) {
    mainLoader.classList.add('loaded')
  }
})

require('normalize.css/normalize.css')
require('./page.scss')

window.addEventListener('load', () => {
  const exploreDecadesSection = document.getElementById('explore-decades')
  const exploreDecadesVideo = document.getElementById('explore-decades-video')
  const exploreDecadesPrompt = document.getElementById('explore-decades-prompt')
  const exploreDecadesBlue = document.getElementById('explore-decades-blue')
  const exploreDecadesNavigate = document.getElementById('explore-decades-navigate')
  const exploreDecadesRadialSvg = document.querySelector('.explore-decades__radial')
  const exploreDecadesRadialLines = document.querySelector('.explore-decades__radial-lines')
  const exploreDecadesDecades = document.querySelector('.explore-decades__decades')
  const exploreDecadesDecadeItems = Array.from(document.querySelectorAll('.explore-decades__decade'))
  const exploreDecadesHighlightRay = document.querySelector('.explore-decades__highlight-ray')
  const exploreDecadesActiveLabel = document.getElementById('explore-decades-active-label')
  const exploreDecadesActiveYear = document.getElementById('explore-decades-active-year')
  const exploreDecadesPanel = document.getElementById('explore-decades-panel')
  const exploreDecadesPanelImage = document.getElementById('explore-decades-panel-image')
  const exploreDecadesPanelTitle = document.getElementById('explore-decades-panel-title')
  const exploreDecadesPanelCta = document.getElementById('explore-decades-panel-cta')
  const exploreDecadesPanelText = document.querySelector('.explore-decades__panel-text')
  const exploreDecadesPanelMedia = document.querySelector('.explore-decades__panel-media')
  const decadeModal = document.getElementById('decade-modal')
  const decadeCloseBtn = document.querySelector('.decade__close')
  const decadeBackBtn = document.getElementById('decade-back')
  const modalTagline = document.getElementById('modal-tagline')
  const modalYearDisplay = document.getElementById('modal-year-display')
  const modalImage = document.getElementById('modal-image')
  const modalTitle = document.getElementById('modal-title')
  const modalDescriptionContainer = document.getElementById('modal-description-container')
  const modalMilestones = document.getElementById('modal-milestones')
  const modalPrevBtn = document.getElementById('decade-prev')
  const modalNextBtn = document.getElementById('decade-next')
  const decadeRadialDivider = document.querySelector('.decade__radial-divider')
  const mobileNav = document.getElementById('explore-decades-mobile-nav')
  const mobilePrevBtn = document.getElementById('explore-decades-mobile-prev')
  const mobileNextBtn = document.getElementById('explore-decades-mobile-next')
  const mobileLabelName = document.getElementById('explore-decades-mobile-name')
  const mobileLabelYear = document.getElementById('explore-decades-mobile-year')
  const shareNavTips = document.querySelector('.explore-decades__share-nav-tips')
  const shareDecadeInfo = document.getElementById('explore-decades-share-decade-info')
  const shareDecadeTitle = document.getElementById('explore-decades-share-decade-title')
  const shareDecadeDesc = document.getElementById('explore-decades-share-decade-desc')
  const shareDecadeCta = document.getElementById('explore-decades-share-decade-cta')

  const isMobile = () => window.innerWidth <= 1024

  if (decadeRadialDivider) {
    const svgNs = 'http://www.w3.org/2000/svg'
    const vW = 1200
    const vH = 260
    // Virtual center well below viewBox — rays emerge upward like the main radial
    const cx = vW / 2 // 600
    const cy = vH + 610 // 870

    // Rays: same quadratic bezier formula as the main radial
    // Avoid angles near -90° (straight up) to prevent the prominent vertical line
    const innerR = 580 // below viewBox bottom (y > 260)
    const outerR = 820 // within viewBox
    const curveAmount = 90
    // Skip the -90° center: use two separate groups, left and right
    const leftAngles = [-128, -120, -112, -104, -98]
    const rightAngles = [-82, -76, -68, -60, -52]
    const allAngles = [...leftAngles, ...rightAngles]

    allAngles.forEach((angleDeg) => {
      const angleRad = (angleDeg * Math.PI) / 180

      const innerX = cx + innerR * Math.cos(angleRad)
      const innerY = cy + innerR * Math.sin(angleRad)
      const outerX = cx + outerR * Math.cos(angleRad)
      const outerY = cy + outerR * Math.sin(angleRad)

      const midR = (innerR + outerR) / 2
      const midX = cx + midR * Math.cos(angleRad)
      const midY = cy + midR * Math.sin(angleRad)
      const ctrlX = midX + (-Math.sin(angleRad)) * curveAmount
      const ctrlY = midY + Math.cos(angleRad) * curveAmount

      const ray = document.createElementNS(svgNs, 'path')
      ray.setAttribute(
        'd',
        `M ${innerX.toFixed(1)} ${innerY.toFixed(1)} Q ${ctrlX.toFixed(1)} ${ctrlY.toFixed(1)} ${outerX.toFixed(1)} ${outerY.toFixed(1)}`
      )
      ray.setAttribute('class', 'decade__divider-ray')
      decadeRadialDivider.appendChild(ray)
    })
  }

  const fullDecadeData = require('../data/decades.json')
  const earlyDaysData = require('../data/early-days.json')

  const radialRevealConfig = {
    lineCount: 100,
    innerRadius: 100,
    outerRadius: 455,
    curveAmount: 100,
    startAngleDeg: -94,
    sweepDuration: 0.8,
    lineFadeDuration: 0.1,
    radialFadeInDuration: 0.4
  }
  let radialRays = []
  let firstRadialRay = null
  let radialLinesAngle = 0

  // Returns the index in radialRays that is visually at -90° after N decade rotations
  const getActiveRayIndex = (decadeIndex) => ((-90 + decadeIndex * 10) % 100 + 100) % 100

  const resetActiveRay = () => {
    if (activeDecadeIndex === -1) return
    const ray = radialRays[getActiveRayIndex(activeDecadeIndex)]
    if (ray) {
      ray.removeAttribute('stroke-opacity')
    }
  }

  const animateRadialRotation = (delta, duration, ease) => {
    const obj = { angle: radialLinesAngle }
    radialLinesAngle += delta
    const targetAngle = radialLinesAngle
    gsap.to(obj, {
      angle: targetAngle,
      duration,
      ease,
      onUpdate: () => {
        exploreDecadesRadialLines.setAttribute('transform', `rotate(${obj.angle}, 500, 500)`)
      }
    })
  }

  const DECADE_STEP = 360 / 11

  const decadeData = [
    { year: '1920s', label: 'The Early Days', title: 'Pioneering the first of many firsts', image: '/static/anniversary290426/assets/anniversity/decades/history-1920-Duotone.png', href: '#', shareTitle: 'The Early Days', shareDesc: 'Experience the origins of SLB' },
    { year: '1930s', label: 'Global Innovation', title: 'A global innovator takes shape', image: '/static/anniversary290426/assets/anniversity/decades/history-1930-Duotone.png', href: '#', shareTitle: 'Global Innovation', shareDesc: 'Discover how SLB shaped a global industry' },
    { year: '1940s', label: 'Evolving Opportunity', title: 'A changing company with growing opportunity', image: '/static/anniversary290426/assets/anniversity/decades/history-1940-Duotone.png', href: '#', shareTitle: 'Evolving Opportunity', shareDesc: 'A decade of change and growing potential' },
    { year: '1950s', label: 'Tech Growth', title: 'New technology, strategic acquisitions', image: '/static/anniversary290426/assets/anniversity/decades/history-1950-Duotone.png', href: '#', shareTitle: 'Tech Growth', shareDesc: 'New technology drives strategic expansion' },
    { year: '1960s', label: 'Expansive Growth', title: 'SLB grows, from the ocean to the moon', image: '/static/anniversary290426/assets/anniversity/decades/history-1960-Duotone.png', href: '#', shareTitle: 'Expansive Growth', shareDesc: 'From the ocean floor to outer space' },
    { year: '1970s', label: 'Driving Innovation', title: 'Innovating to lead', image: '/static/anniversary290426/assets/anniversity/decades/history-1970-Duotone.png', href: '#', shareTitle: 'Driving Innovation', shareDesc: 'Leading the industry through bold innovation' },
    { year: '1980s', label: 'Global Connections', title: 'Connecting minds across the world', image: '/static/anniversary290426/assets/anniversity/decades/history-1980-Duotone.png', href: '#', shareTitle: 'Global Connections', shareDesc: 'Building bridges across continents' },
    { year: '1990s', label: 'Product Power', title: 'Creating powerful new products', image: '/static/anniversary290426/assets/anniversity/decades/history-1990-Duotone.png', href: '#', shareTitle: 'Product Power', shareDesc: 'A decade defined by breakthrough products' },
    { year: '2000s', label: 'Renewed Foundations', title: 'Recommitted to the foundations of SLB', image: '/static/anniversary290426/assets/anniversity/decades/history-2000-Duotone.png', href: '#', shareTitle: 'Renewed Foundations', shareDesc: 'Returning to core values with new purpose' },
    { year: '2010s', label: 'Energy Transitions', title: 'Adapting to a new energy landscape', image: '/static/anniversary290426/assets/anniversity/decades/history-2010-Duotone.png', href: '#', shareTitle: 'Energy Transitions', shareDesc: 'Adapting to the future of energy' },
    { year: '2020s', label: 'Always Thinking Ahead', title: 'Every great legacy has an eye on tomorrow', image: '/static/anniversary290426/assets/anniversity/decades/history-2020-Duotone.png', href: '#', shareTitle: 'Always Thinking Ahead', shareDesc: 'Building tomorrow\'s energy solutions today' }
  ]

  const baseAngles = [-90, -57.3, -24.5, 8.2, 40.9, 73.6, 106.4, 139.1, 171.8, 204.5, 237.3]
  let rotationOffset = 0
  let activeDecadeIndex = -1
  let isRotating = false
  let rotationEnabled = false
  let contentRevealTimer = null
  let firstActivation = true
  let shareInfoRevealed = false
  let isModalOpen = false
  let isEarlyDaysModal = false
  let milestoneScrollObserver = null
  let modalScrollDirection = 'down'
  let modalScrollHandler = null

  let lastTouchY = 0
  let isScrolling = false
  let scrollStopTimer = null
  let activeTween = null
  let isDragging = false
  let lastDragAngle = 0
  let dragMoved = false
  let dragVelocity = 0
  let lastDragTime = 0

  const hideContentForScroll = () => {
    resetActiveRay()
    if (exploreDecadesPanel) gsap.to(exploreDecadesPanel, { opacity: 0, duration: 0.15 })
    if (activeDecadeIndex !== -1 && exploreDecadesDecadeItems[activeDecadeIndex]) {
      exploreDecadesDecadeItems[activeDecadeIndex].classList.remove('explore-decades__decade--active')
    }
  }

  const snapToNearest = () => {
    const nearestStep = Math.round(-rotationOffset / DECADE_STEP)
    const nearestIndex = ((nearestStep % 11) + 11) % 11
    const totalDelta = -(nearestStep * DECADE_STEP) - rotationOffset
    if (Math.abs(totalDelta) < 0.5) {
      isRotating = false
      activateDecade(nearestIndex)
      return
    }
    snapToDecade(nearestIndex, totalDelta)
  }

  const handleWheel = (e) => {
    if (!rotationEnabled || isModalOpen) return
    if (firstActivation) {
      firstActivation = false
      activateDecade(0)
      return
    }
    if (activeTween) { activeTween.kill(); activeTween = null }
    isRotating = false
    if (!isScrolling) {
      isScrolling = true
      hideContentForScroll()
    }
    const delta = -e.deltaY * 0.1
    radialLinesAngle += delta
    rotationOffset += delta
    exploreDecadesRadialLines.setAttribute('transform', `rotate(${radialLinesAngle}, 500, 500)`)
    positionExploreDecades(false)
    clearTimeout(scrollStopTimer)
    scrollStopTimer = setTimeout(() => {
      isScrolling = false
      snapToNearest()
    }, 180)
  }

  const handleTouchStart = (e) => {
    lastTouchY = e.touches[0].clientY
    if (activeTween) { activeTween.kill(); activeTween = null }
    isRotating = false
  }

  const handleTouchMove = (e) => {
    if (!rotationEnabled || isModalOpen) return
    const currentY = e.touches[0].clientY
    const deltaY = lastTouchY - currentY
    lastTouchY = currentY
    if (Math.abs(deltaY) < 1) return
    if (firstActivation) {
      firstActivation = false
      activateDecade(0)
      return
    }
    if (!isScrolling) {
      isScrolling = true
      hideContentForScroll()
    }
    const delta = -deltaY * 0.4
    radialLinesAngle += delta
    rotationOffset += delta
    exploreDecadesRadialLines.setAttribute('transform', `rotate(${radialLinesAngle}, 500, 500)`)
    positionExploreDecades(false)
    clearTimeout(scrollStopTimer)
    scrollStopTimer = setTimeout(() => {
      isScrolling = false
      snapToNearest()
    }, 200)
  }

  const handleTouchEnd = () => {
    if (!rotationEnabled || isModalOpen || firstActivation) return
    clearTimeout(scrollStopTimer)
    isScrolling = false
    snapToNearest()
  }

  const getPointerAngle = (clientX, clientY) => {
    const rect = exploreDecadesRadialSvg.getBoundingClientRect()
    const cx = rect.left + rect.width / 2
    const cy = rect.top + rect.height / 2
    return Math.atan2(clientY - cy, clientX - cx) * 180 / Math.PI
  }

  const handleDragStart = (e) => {
    if (!rotationEnabled || isModalOpen || e.button !== 0) return
    if (firstActivation) {
      firstActivation = false
      activateDecade(0)
      return
    }
    isDragging = true
    dragMoved = false
    dragVelocity = 0
    lastDragTime = performance.now()
    lastDragAngle = getPointerAngle(e.clientX, e.clientY)
    if (activeTween) { activeTween.kill(); activeTween = null }
    isRotating = false
  }

  const handleDragMove = (e) => {
    if (!isDragging || !rotationEnabled || isModalOpen) return
    const currentAngle = getPointerAngle(e.clientX, e.clientY)
    let delta = currentAngle - lastDragAngle
    if (delta > 180) delta -= 360
    if (delta < -180) delta += 360
    lastDragAngle = currentAngle
    if (Math.abs(delta) < 0.05) return
    const now = performance.now()
    const dt = Math.max(now - lastDragTime, 1)
    dragVelocity = dragVelocity * 0.65 + (delta / dt) * 0.35
    lastDragTime = now
    if (!dragMoved) {
      dragMoved = true
      isScrolling = true
      hideContentForScroll()
      if (exploreDecadesBlue) exploreDecadesBlue.style.cursor = 'grabbing'
    }
    radialLinesAngle += delta
    rotationOffset += delta
    exploreDecadesRadialLines.setAttribute('transform', `rotate(${radialLinesAngle}, 500, 500)`)
    positionExploreDecades(false)
  }

  const handleDragEnd = () => {
    if (!isDragging) return
    isDragging = false
    if (exploreDecadesBlue) exploreDecadesBlue.style.cursor = ''
    if (!dragMoved || !rotationEnabled || isModalOpen) return

    if (Math.abs(dragVelocity) > 0.05) {
      const momentumDelta = dragVelocity * 200
      const momentumDuration = Math.min(Math.abs(dragVelocity) * 1200, 1.2)
      const momentumObj = { angle: radialLinesAngle }
      activeTween = gsap.to(momentumObj, {
        angle: radialLinesAngle + momentumDelta,
        duration: momentumDuration,
        ease: 'power2.out',
        onUpdate: () => {
          const diff = momentumObj.angle - radialLinesAngle
          rotationOffset += diff
          radialLinesAngle = momentumObj.angle
          exploreDecadesRadialLines.setAttribute('transform', `rotate(${radialLinesAngle}, 500, 500)`)
          positionExploreDecades(false)
        },
        onComplete: () => {
          activeTween = null
          isScrolling = false
          snapToNearest()
        }
      })
    } else {
      isScrolling = false
      snapToNearest()
    }
  }

  if (exploreDecadesRadialSvg && exploreDecadesRadialLines) {
    const centerX = 500
    const centerY = 500
    const startAngleRad = (radialRevealConfig.startAngleDeg * Math.PI) / 180
    const stepAngle = (Math.PI * 2) / radialRevealConfig.lineCount
    const svgNs = 'http://www.w3.org/2000/svg'

    radialRays = Array.from({ length: radialRevealConfig.lineCount }, (_, index) => {
      const angle = startAngleRad + (index * stepAngle)
      const innerX = centerX + (Math.cos(angle) * radialRevealConfig.innerRadius)
      const innerY = centerY + (Math.sin(angle) * radialRevealConfig.innerRadius)
      const outerX = centerX + (Math.cos(angle) * radialRevealConfig.outerRadius)
      const outerY = centerY + (Math.sin(angle) * radialRevealConfig.outerRadius)
      const midRadius = (radialRevealConfig.innerRadius + radialRevealConfig.outerRadius) / 2
      const midX = centerX + (Math.cos(angle) * midRadius)
      const midY = centerY + (Math.sin(angle) * midRadius)
      const tangentX = -Math.sin(angle)
      const tangentY = Math.cos(angle)
      const controlX = midX + (tangentX * radialRevealConfig.curveAmount)
      const controlY = midY + (tangentY * radialRevealConfig.curveAmount)
      const ray = document.createElementNS(svgNs, 'path')
      ray.setAttribute('class', 'explore-decades__radial-ray')
      ray.setAttribute(
        'd',
        `M ${innerX.toFixed(2)} ${innerY.toFixed(2)} Q ${controlX.toFixed(2)} ${controlY.toFixed(2)} ${outerX.toFixed(2)} ${outerY.toFixed(2)}`
      )
      ray.style.opacity = '0'
      exploreDecadesRadialLines.appendChild(ray)
      return ray
    })

    firstRadialRay = radialRays[0] || null

    // Generate highlight ray at -90° using same formula (innerRadius=0 → goes to center)
    const highlightGroup = document.querySelector('.explore-decades__highlight-lines')
    if (highlightGroup && exploreDecadesHighlightRay) {
      const hAngle = (-90 * Math.PI) / 180
      const hOuterX = centerX + (Math.cos(hAngle) * radialRevealConfig.outerRadius)
      const hOuterY = centerY + (Math.sin(hAngle) * radialRevealConfig.outerRadius)
      const hMidRadius = radialRevealConfig.outerRadius / 2
      const hMidX = centerX + (Math.cos(hAngle) * hMidRadius)
      const hMidY = centerY + (Math.sin(hAngle) * hMidRadius)
      const hTangentX = -Math.sin(hAngle)
      const hTangentY = Math.cos(hAngle)
      const hControlX = hMidX + (hTangentX * radialRevealConfig.curveAmount)
      const hControlY = hMidY + (hTangentY * radialRevealConfig.curveAmount)
      exploreDecadesHighlightRay.setAttribute(
        'd',
        `M ${centerX.toFixed(2)} ${centerY.toFixed(2)} Q ${hControlX.toFixed(2)} ${hControlY.toFixed(2)} ${hOuterX.toFixed(2)} ${hOuterY.toFixed(2)}`
      )
    }
  }

  const positionExploreDecades = (animated = false) => {
    if (!exploreDecadesBlue || !exploreDecadesRadialSvg || exploreDecadesDecadeItems.length === 0) return

    const blueRect = exploreDecadesBlue.getBoundingClientRect()
    const radialRect = exploreDecadesRadialSvg.getBoundingClientRect()
    const centerX = blueRect.width / 2
    const centerY = blueRect.height / 2
    const svgHalfSize = Math.min(radialRect.width, radialRect.height) / 2
    const circleRadius = (radialRevealConfig.outerRadius / 500) * svgHalfSize
    const gap = 60
    const viewportPadding = window.innerWidth <= 768 ? 12 : 24

    exploreDecadesDecadeItems.forEach((item, i) => {
      const angleDeg = baseAngles[i] + rotationOffset
      const angleRad = (angleDeg * Math.PI) / 180
      const posRadius = circleRadius + gap
      const cosA = Math.cos(angleRad)
      const sinA = Math.sin(angleRad)
      const rawX = centerX + (cosA * posRadius)
      const rawY = centerY + (sinA * posRadius)
      const halfWidth = item.offsetWidth / 2
      const halfHeight = item.offsetHeight / 2
      const x = Math.max(viewportPadding + halfWidth, Math.min(rawX, blueRect.width - viewportPadding - halfWidth))
      const y = Math.max(viewportPadding + halfHeight, Math.min(rawY, blueRect.height - viewportPadding - halfHeight))

      if (animated) {
        gsap.to(item, { left: x, top: y, duration: 0.8, ease: 'power2.inOut' })
      } else {
        item.style.left = x + 'px'
        item.style.top = y + 'px'
      }
    })
  }

  const activateDecade = (index) => {
    if (activeDecadeIndex !== -1 && exploreDecadesDecadeItems[activeDecadeIndex]) {
      exploreDecadesDecadeItems[activeDecadeIndex].classList.remove('explore-decades__decade--active')
    }
    activeDecadeIndex = index
    if (exploreDecadesDecadeItems[index]) {
      exploreDecadesDecadeItems[index].classList.add('explore-decades__decade--active')
    }

    const activeRay = radialRays[getActiveRayIndex(index)]
    if (activeRay && exploreDecadesRadialLines) {
      exploreDecadesRadialLines.appendChild(activeRay)
    }

    const data = decadeData[index]

    if (exploreDecadesActiveLabel) exploreDecadesActiveLabel.textContent = data.label
    if (exploreDecadesActiveYear) exploreDecadesActiveYear.textContent = data.year
    if (mobileLabelName) mobileLabelName.textContent = data.label
    if (mobileLabelYear) mobileLabelYear.textContent = data.year
    // if (exploreDecadesActiveHeader) gsap.to(exploreDecadesActiveHeader, { opacity: 1, duration: 0.6, ease: 'power2.out' })

    if (exploreDecadesNavigate) {
      gsap.to(exploreDecadesNavigate, {
        opacity: 0,
        duration: 0.4,
        onComplete: () => { exploreDecadesNavigate.style.pointerEvents = 'none' }
      })
    }

    if (exploreDecadesPanelText) gsap.set(exploreDecadesPanelText, { opacity: 0, top: 0 })
    if (exploreDecadesPanelCta) gsap.set(exploreDecadesPanelCta, { opacity: 0 })
    if (exploreDecadesPanelImage) {
      gsap.set(exploreDecadesPanelImage, { opacity: 0 })
      exploreDecadesPanelImage.onload = () => {
        gsap.to(exploreDecadesPanelImage, { opacity: 1, duration: 0.4, ease: 'power2.out' })
      }
      exploreDecadesPanelImage.src = data.image
    }
    if (exploreDecadesPanelCta) exploreDecadesPanelCta.href = data.href
    if (exploreDecadesPanel) {
      exploreDecadesPanel.style.pointerEvents = 'auto'
      gsap.to(exploreDecadesPanel, { opacity: 1, duration: 0.4, ease: 'power2.out' })
    }
    if (exploreDecadesPanelMedia && !isMobile()) {
      gsap.fromTo(exploreDecadesPanelMedia, { width: 243, height: 136 }, { width: 322, height: 180, duration: 0.5, ease: 'power2.out', delay: 0.2 })
    }

    if (shareNavTips && shareDecadeInfo && !shareInfoRevealed) {
      shareInfoRevealed = true
      gsap.to(shareNavTips, {
        opacity: 0,
        duration: 0.25,
        ease: 'power2.in',
        onComplete: () => {
          shareNavTips.style.display = 'none'
          if (shareDecadeTitle) shareDecadeTitle.textContent = data.shareTitle
          if (shareDecadeDesc) shareDecadeDesc.textContent = data.shareDesc
          if (shareDecadeCta) {
            shareDecadeCta.onclick = () => {
              if (firstActivation) { firstActivation = false; activateDecade(0) }
              isModalOpen = true
              isEarlyDaysModal = true
              if (mobileNav) mobileNav.style.pointerEvents = 'none'
              updateModalContent(earlyDaysData)
              decadeModal.scrollTop = 0
              decadeModal.style.visibility = 'visible'
              if (modalPrevBtn) gsap.set(modalPrevBtn, { x: 80, opacity: 0 })
              if (modalNextBtn) gsap.set(modalNextBtn, { x: -80, opacity: 0 })
              if (decadeCloseBtn) gsap.set(decadeCloseBtn, { y: -30, opacity: 0 })
              if (decadeRadialDivider) gsap.set(decadeRadialDivider, { opacity: 0 })
              gsap.fromTo(decadeModal,
                { opacity: 0, scale: 1.04 },
                {
                  opacity: 1,
                  scale: 1,
                  duration: 0.5,
                  ease: 'power2.out',
                  onComplete: () => {
                    if (modalPrevBtn) gsap.to(modalPrevBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
                    if (modalNextBtn) gsap.to(modalNextBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
                    if (decadeCloseBtn) gsap.to(decadeCloseBtn, { y: 0, opacity: 1, duration: 0.4, ease: 'back.out(1.7)' })
                    if (decadeRadialDivider) gsap.to(decadeRadialDivider, { opacity: 1, duration: 1, ease: 'power2.out' })
                  }
                }
              )
            }
          }
          shareDecadeInfo.style.display = 'block'
          gsap.fromTo(shareDecadeInfo,
            { opacity: 0 },
            { opacity: 1, duration: 0.4, ease: 'power2.out' }
          )
        }
      })
    }

    clearTimeout(contentRevealTimer)
    contentRevealTimer = setTimeout(() => {
      if (exploreDecadesPanelTitle) exploreDecadesPanelTitle.textContent = data.title
      if (exploreDecadesPanelText) {
        gsap.fromTo(exploreDecadesPanelText,
          { opacity: 0, top: 0 },
          { opacity: 1, top: isMobile() ? (window.innerWidth <= 375 ? 50 : 22) : -25, duration: 0.5, delay: 0.2, ease: 'back.out(1.7)' }
        )
      }
      if (exploreDecadesPanelCta) {
        gsap.fromTo(exploreDecadesPanelCta, { opacity: 0 }, { opacity: 1, duration: 0.5, delay: 0.2, ease: 'power2.out' })
      }
    })
  }

  const rotateStep = () => {
    if (!rotationEnabled || isRotating) return
    isRotating = true

    resetActiveRay()
    if (exploreDecadesPanel) gsap.to(exploreDecadesPanel, { opacity: 0, duration: 0.3 })
    // if (exploreDecadesActiveHeader) gsap.to(exploreDecadesActiveHeader, { opacity: 0, duration: 0.3 })
    if (activeDecadeIndex !== -1 && exploreDecadesDecadeItems[activeDecadeIndex]) {
      exploreDecadesDecadeItems[activeDecadeIndex].classList.remove('explore-decades__decade--active')
    }

    rotationOffset -= DECADE_STEP
    const step = Math.round(-rotationOffset / DECADE_STEP)
    const newActiveIndex = ((step % 11) + 11) % 11

    animateRadialRotation(-DECADE_STEP, 0.8, 'power2.inOut')
    positionExploreDecades(true)

    setTimeout(() => {
      isRotating = false
      activateDecade(newActiveIndex)
    }, 800)
  }

  const rotateStepBack = () => {
    if (!rotationEnabled || isRotating) return
    isRotating = true

    resetActiveRay()
    if (exploreDecadesPanel) gsap.to(exploreDecadesPanel, { opacity: 0, duration: 0.3 })
    if (activeDecadeIndex !== -1 && exploreDecadesDecadeItems[activeDecadeIndex]) {
      exploreDecadesDecadeItems[activeDecadeIndex].classList.remove('explore-decades__decade--active')
    }

    rotationOffset += DECADE_STEP
    const step = Math.round(-rotationOffset / DECADE_STEP)
    const newActiveIndex = ((step % 11) + 11) % 11

    animateRadialRotation(DECADE_STEP, 0.8, 'power2.inOut')
    positionExploreDecades(true)

    setTimeout(() => {
      isRotating = false
      activateDecade(newActiveIndex)
    }, 800)
  }

  const SNAP_THRESHOLD = 1

  const snapToDecade = (targetIndex, totalDelta) => {
    isRotating = true

    resetActiveRay()
    if (exploreDecadesPanel) gsap.to(exploreDecadesPanel, { opacity: 0, duration: 0.15 })
    if (activeDecadeIndex !== -1 && exploreDecadesDecadeItems[activeDecadeIndex]) {
      exploreDecadesDecadeItems[activeDecadeIndex].classList.remove('explore-decades__decade--active')
    }

    exploreDecadesDecadeItems.forEach(item => gsap.killTweensOf(item))

    const startOffset = rotationOffset
    const startAngle = radialLinesAngle
    const steps = Math.abs(totalDelta) / DECADE_STEP
    const duration = Math.min(0.4 + steps * 0.12, 0.9)

    const proxy = { value: 0 }
    activeTween = gsap.to(proxy, {
      value: 1,
      duration: duration,
      ease: 'power2.inOut',
      onUpdate: function () {
        rotationOffset = startOffset + totalDelta * proxy.value
        exploreDecadesRadialLines.setAttribute('transform', `rotate(${startAngle + totalDelta * proxy.value}, 500, 500)`)
        positionExploreDecades(false)
      },
      onComplete: function () {
        rotationOffset = startOffset + totalDelta
        radialLinesAngle = startAngle + totalDelta
        exploreDecadesRadialLines.setAttribute('transform', `rotate(${radialLinesAngle}, 500, 500)`)
        positionExploreDecades(false)
        activeTween = null
        isRotating = false
        activateDecade(targetIndex)
      }
    })
  }

  const rotateToDecade = (targetIndex) => {
    if (!rotationEnabled || isRotating) return
    if (firstActivation) {
      firstActivation = false
      activeDecadeIndex = 0
    }
    if (targetIndex === activeDecadeIndex) return
    const forwardSteps = ((targetIndex - activeDecadeIndex) + 11) % 11
    const backwardSteps = 11 - forwardSteps
    if (forwardSteps === 0) return
    const steps = forwardSteps <= backwardSteps ? forwardSteps : backwardSteps
    const isForward = forwardSteps <= backwardSteps

    if (steps > SNAP_THRESHOLD) {
      const totalDelta = isForward ? -(steps * DECADE_STEP) : (steps * DECADE_STEP)
      snapToDecade(targetIndex, totalDelta)
      return
    }

    const stepFn = isForward ? rotateStep : rotateStepBack
    const executeNext = (remaining) => {
      if (remaining <= 0) return
      stepFn()
      if (remaining > 1) setTimeout(() => executeNext(remaining - 1), 820)
    }
    executeNext(steps)
  }

  exploreDecadesDecadeItems.forEach((item, clickedIndex) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation()
      const d = decadeData[clickedIndex]
      if (d) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'anniversary_decade_click',
          cd_click_text: d.label + ' ' + d.year
        })
      }
      rotateToDecade(clickedIndex)
    })
  })

  // Rotate radial SVG from within the modal (prev/next arrows)
  const rotateForModal = (targetIndex) => {
    const targetOffset = -(targetIndex * DECADE_STEP)
    const delta = targetOffset - rotationOffset
    rotationOffset = targetOffset
    animateRadialRotation(delta, 0.6, 'power2.inOut')
    positionExploreDecades(true)

    exploreDecadesDecadeItems.forEach(item => item.classList.remove('explore-decades__decade--active'))
    if (exploreDecadesDecadeItems[targetIndex]) {
      exploreDecadesDecadeItems[targetIndex].classList.add('explore-decades__decade--active')
    }

    const data = decadeData[targetIndex]
    if (data) {
      if (exploreDecadesActiveLabel) exploreDecadesActiveLabel.textContent = data.label
      if (exploreDecadesActiveYear) exploreDecadesActiveYear.textContent = data.year
      if (exploreDecadesPanelImage) exploreDecadesPanelImage.src = data.image
      if (exploreDecadesPanelTitle) exploreDecadesPanelTitle.textContent = data.title
      if (exploreDecadesPanelCta) exploreDecadesPanelCta.href = data.href
    }
  }

  const parseLinks = (text) =>
    text.replace(/\[\[(.+?)\|(.+?)\]\]/g, (_, label, url) =>
      `<a href="${url}" target="_blank" rel="noopener noreferrer" class="decade__link">${label}</a>`
    )

  // Modal open/close
  const updateModalContent = (index) => {
    const data = typeof index === 'object' ? index : fullDecadeData[index]
    if (!data) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'anniversary_card_view',
      cd_event_action: data.title,
      cd_event_label: data.tagline + ' ' + data.year_range
    })

    const isEarlyDays = data.frame_name === 'The_Early_Days'
    if (modalTagline) modalTagline.textContent = data.tagline
    if (modalYearDisplay) {
      modalYearDisplay.textContent = data.year_range
      modalYearDisplay.style.display = isEarlyDays ? 'none' : ''
    }
    if (modalImage) {
      gsap.killTweensOf(modalImage)
      gsap.set(modalImage, { opacity: 0 })
      modalImage.onload = () => {
        gsap.to(modalImage, { opacity: 1, duration: 0.25, ease: 'power2.out' })
        modalImage.onload = null
      }
      modalImage.src = data.image
      if (modalImage.complete) {
        modalImage.onload()
      }
    }
    if (modalTitle) modalTitle.textContent = data.title

    // Populate descriptions
    if (modalDescriptionContainer) {
      modalDescriptionContainer.innerHTML = ''
      let bulletGroup = null
      data.description.forEach(item => {
        if (typeof item === 'object' && item.type === 'bullet') {
          if (!bulletGroup) {
            bulletGroup = document.createElement('ul')
            bulletGroup.className = 'decade__bullets'
            modalDescriptionContainer.appendChild(bulletGroup)
          }
          const li = document.createElement('li')
          li.className = 'decade__bullet'
          li.innerHTML = `<span class="decade__bullet-arrow" aria-hidden="true"></span><p>${parseLinks(item.text)}</p>`
          bulletGroup.appendChild(li)
        } else {
          bulletGroup = null
          const p = document.createElement('p')
          p.className = 'decade__description'
          p.innerHTML = parseLinks(typeof item === 'string' ? item : item.text)
          if (typeof item === 'object' && item.image) {
            p.dataset.image = item.image
          }
          modalDescriptionContainer.appendChild(p)
        }
      })
    }

    let lastShownImageEl = null
    const swapImage = (src) => {
      if (!modalImage) return
      gsap.to(modalImage, {
        opacity: 0,
        duration: 0.2,
        onComplete: () => {
          modalImage.src = src
          gsap.to(modalImage, { opacity: 1, duration: 0.25 })
        }
      })
    }

    // Populate milestones
    if (modalMilestones) {
      modalMilestones.innerHTML = ''
      data.milestones.forEach((ms, i) => {
        const milestoneDiv = document.createElement('div')
        milestoneDiv.className = 'decade__milestone'
        if (ms.image) milestoneDiv.dataset.image = ms.image
        if (ms.highlight === false) milestoneDiv.dataset.highlight = 'false'

        const yearSpan = document.createElement('span')
        yearSpan.className = 'decade__year'
        yearSpan.textContent = ms.year

        const eventP = document.createElement('p')
        eventP.className = 'decade__event'
        eventP.innerHTML = parseLinks(ms.event)

        milestoneDiv.appendChild(yearSpan)
        milestoneDiv.appendChild(eventP)
        modalMilestones.appendChild(milestoneDiv)
      })

      if (milestoneScrollObserver) milestoneScrollObserver.disconnect()

      const milestoneEls = modalMilestones.querySelectorAll('.decade__milestone')
      const milestoneElsArray = Array.from(milestoneEls)
      const visibleMilestones = new Set()

      milestoneScrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            visibleMilestones.add(entry.target)
          } else {
            visibleMilestones.delete(entry.target)
          }
        })
        if (visibleMilestones.size === 0) return
        if (window.innerWidth < 1199) return
        if (decadeModal.scrollTop < 80) return

        const visible = milestoneElsArray.filter(el =>
          visibleMilestones.has(el) && el.dataset.highlight !== 'false'
        )
        if (visible.length === 0) return

        const activeEl = modalScrollDirection === 'up' ? visible[0] : visible[visible.length - 1]
        if (!activeEl || activeEl === lastShownImageEl) return

        milestoneEls.forEach(el => {
          const y = el.querySelector('.decade__year')
          if (y) y.classList.remove('decade__year--active')
        })
        const yearEl = activeEl.querySelector('.decade__year')
        if (yearEl) yearEl.classList.add('decade__year--active')
        const img = activeEl.dataset.image
        if (img) {
          lastShownImageEl = activeEl
          swapImage(img)
        }
      }, {
        root: decadeModal,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0
      })

      milestoneEls.forEach(el => milestoneScrollObserver.observe(el))
    }

    if (decadeModal) {
      if (modalScrollHandler) decadeModal.removeEventListener('scroll', modalScrollHandler)
      let wasAtTop = true
      let lastModalScrollTop = 0
      modalScrollHandler = () => {
        const currentTop = decadeModal.scrollTop
        modalScrollDirection = currentTop > lastModalScrollTop ? 'down' : 'up'
        lastModalScrollTop = currentTop

        if (currentTop < 80) {
          if (!wasAtTop) {
            wasAtTop = true
            lastShownImageEl = null
            swapImage(data.image)
          }
          return
        }
        wasAtTop = false
      }
      decadeModal.addEventListener('scroll', modalScrollHandler)
    }
  }

  if (exploreDecadesPanelCta && decadeModal) {
    exploreDecadesPanelCta.addEventListener('click', (e) => {
      e.preventDefault()
      isModalOpen = true
      if (mobileNav) mobileNav.style.pointerEvents = 'none'
      updateModalContent(activeDecadeIndex)
      decadeModal.scrollTop = 0
      decadeModal.style.visibility = 'visible'

      // Reset positions before animating
      if (modalPrevBtn) gsap.set(modalPrevBtn, { x: 80, opacity: 0 })
      if (modalNextBtn) gsap.set(modalNextBtn, { x: -80, opacity: 0 })
      if (decadeCloseBtn) gsap.set(decadeCloseBtn, { y: -30, opacity: 0 })
      if (decadeRadialDivider) gsap.set(decadeRadialDivider, { opacity: 0 })

      gsap.fromTo(decadeModal,
        { opacity: 0, scale: 1.04 },
        {
          opacity: 1,
          scale: 1,
          duration: 0.5,
          ease: 'power2.out',
          onComplete: () => {
            // Left arrow enters from right → left
            if (modalPrevBtn) {
              gsap.to(modalPrevBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
            }
            // Right arrow enters from left → right
            if (modalNextBtn) {
              gsap.to(modalNextBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
            }
            // Close button drops in from above
            if (decadeCloseBtn) {
              gsap.to(decadeCloseBtn, { y: 0, opacity: 1, duration: 0.4, ease: 'back.out(1.7)' })
            }
            // Radial divider fades in
            if (decadeRadialDivider) {
              gsap.to(decadeRadialDivider, { opacity: 1, duration: 1, ease: 'power2.out' })
            }
          }
        }
      )
    })
  }

  const navigateModal = (direction) => {
    if (decadeModal) decadeModal.scrollTop = 0
    if (modalImage) gsap.set(modalImage, { opacity: 0 })

    const last = fullDecadeData.length - 1
    const next = direction === 'next'
    const xFrom = next ? 20 : -20

    const goToDecade = (index) => {
      isEarlyDaysModal = false
      activeDecadeIndex = index
      updateModalContent(activeDecadeIndex)
      rotateForModal(activeDecadeIndex)
    }

    const goToEarlyDays = () => {
      isEarlyDaysModal = true
      updateModalContent(earlyDaysData)
    }

    if (isEarlyDaysModal) goToDecade(next ? 0 : last)
    else if (next && activeDecadeIndex === last) goToEarlyDays()
    else if (!next && activeDecadeIndex === 0) goToEarlyDays()
    else goToDecade(activeDecadeIndex + (next ? 1 : -1))

    gsap.fromTo('.decade__hero', { opacity: 0, x: xFrom }, { opacity: 1, x: 0, duration: 0.5 })
  }

  if (modalPrevBtn) modalPrevBtn.addEventListener('click', () => navigateModal('prev'))
  if (modalNextBtn) modalNextBtn.addEventListener('click', () => navigateModal('next'))

  if (decadeBackBtn && decadeModal) {
    decadeBackBtn.addEventListener('click', () => {
      isModalOpen = false
      isEarlyDaysModal = false
      if (activeDecadeIndex >= 0) rotateForModal(activeDecadeIndex)
      if (isMobile() && mobileNav) mobileNav.style.pointerEvents = 'auto'
      if (decadeRadialDivider) gsap.to(decadeRadialDivider, { opacity: 0, duration: 0.25, ease: 'power2.in' })
      gsap.to(decadeModal, {
        opacity: 0,
        scale: 1.04,
        duration: 0.35,
        ease: 'power2.in',
        onComplete: () => {
          gsap.set(decadeModal, { scale: 1 })
          decadeModal.scrollTop = 0
          decadeModal.style.visibility = 'hidden'
        }
      })
    })
  }

  if (decadeCloseBtn && decadeModal) {
    decadeCloseBtn.addEventListener('click', () => {
      isModalOpen = false
      isEarlyDaysModal = false
      if (activeDecadeIndex >= 0) rotateForModal(activeDecadeIndex)
      if (isMobile() && mobileNav) mobileNav.style.pointerEvents = 'auto'
      if (decadeRadialDivider) gsap.to(decadeRadialDivider, { opacity: 0, duration: 0.25, ease: 'power2.in' })
      gsap.to(decadeModal, {
        opacity: 0,
        scale: 1.04,
        duration: 0.35,
        ease: 'power2.in',
        onComplete: () => {
          gsap.set(decadeModal, { scale: 1 })
          decadeModal.scrollTop = 0
          decadeModal.style.visibility = 'hidden'
        }
      })
    })
  }

  // Mobile browse navigation
  if (mobilePrevBtn) {
    mobilePrevBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      rotateStepBack()
    })
  }

  if (mobileNextBtn) {
    mobileNextBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      rotateStep()
    })
  }

  // Start video on load and show prompt
  if (exploreDecadesVideo) {
    exploreDecadesVideo.play()
  }

  if (exploreDecadesPrompt) {
    exploreDecadesPrompt.classList.add('is-visible')
  }

  positionExploreDecades()
  window.addEventListener('resize', positionExploreDecades)

  // Build the full auto-play timeline (paused at start)
  const tl = gsap.timeline({
    paused: true,
    onComplete: () => {
      rotationEnabled = true

      window.addEventListener('wheel', handleWheel, { passive: true })
      window.addEventListener('touchstart', handleTouchStart, { passive: true })
      window.addEventListener('touchmove', handleTouchMove, { passive: true })
      window.addEventListener('touchend', handleTouchEnd, { passive: true })
      if (exploreDecadesBlue) {
        exploreDecadesBlue.addEventListener('mousedown', handleDragStart)
      }
      document.addEventListener('mousemove', handleDragMove)
      document.addEventListener('mouseup', handleDragEnd)
      if (exploreDecadesSection) {
        exploreDecadesSection.addEventListener('click', () => {
          if (!rotationEnabled || isModalOpen) return
          if (dragMoved) { dragMoved = false; return }
          if (firstActivation) { firstActivation = false; activateDecade(0); return }
          rotateStep()
        })
      }
    }
  })

  // Prompt disappears immediately
  tl.to(exploreDecadesPrompt, {
    opacity: 0,
    display: 'none',
    duration: 0.2,
    ease: 'power2.in'
  }, 0)

  // PHASE 1: Video fades out → blue state + title appear
  tl.to(exploreDecadesBlue, {
    opacity: 1,
    visibility: 'visible',
    duration: 0.5,
    ease: 'power2.inOut'
  }, 0)
    .to(exploreDecadesVideo, {
      opacity: 0,
      duration: 0.5,
      ease: 'power2.inOut',
      onComplete: () => {
        if (exploreDecadesVideo) exploreDecadesVideo.pause()
      }
    }, 0)
    .to('.explore-decades__title', {
      opacity: 1,
      y: 0,
      duration: 0.4,
      ease: 'power2.out'
    }, 0.3)
    .to('.explore-decades__share', {
      opacity: 1,
      duration: 0.4,
      ease: 'power2.out'
    }, '<')

  // PHASE 2: Title sustains then fades out → subtitle appears
  tl.to('.explore-decades__title', {
    opacity: 0,
    y: -80,
    duration: 0.4,
    ease: 'power2.in'
  }, '+=0.5')
    .to('.explore-decades__subtitle', {
      opacity: 1,
      duration: 0.4,
      ease: 'power2.out'
    }, '-=0.2')

  // PHASE 3: Subtitle sustains, then radial + decades appear automatically
  tl.to('.explore-decades__radial-container', {
    opacity: 1,
    duration: 0.4,
    ease: 'power2.inOut'
  }, '+=0.3')

  if (firstRadialRay) {
    tl.set(firstRadialRay, { opacity: 1 }, '-=0.8')
  }

  tl.call(() => {
    if (shareNavTips && shareDecadeInfo && !shareInfoRevealed) {
      shareInfoRevealed = true
      gsap.to(shareNavTips, {
        opacity: 0,
        duration: 0.25,
        ease: 'power2.in',
        onComplete: () => {
          shareNavTips.style.display = 'none'
          if (shareDecadeTitle) shareDecadeTitle.textContent = earlyDaysData.shareTitle || earlyDaysData.tagline
          if (shareDecadeDesc) shareDecadeDesc.textContent = earlyDaysData.title
          if (shareDecadeCta) {
            shareDecadeCta.onclick = () => {
              if (firstActivation) {
                firstActivation = false
                activateDecade(0)
              }
              isModalOpen = true
              isEarlyDaysModal = true
              if (mobileNav) mobileNav.style.pointerEvents = 'none'
              updateModalContent(earlyDaysData)
              decadeModal.scrollTop = 0
              decadeModal.style.visibility = 'visible'
              if (modalPrevBtn) gsap.set(modalPrevBtn, { x: 80, opacity: 0 })
              if (modalNextBtn) gsap.set(modalNextBtn, { x: -80, opacity: 0 })
              if (decadeCloseBtn) gsap.set(decadeCloseBtn, { y: -30, opacity: 0 })
              if (decadeRadialDivider) gsap.set(decadeRadialDivider, { opacity: 0 })
              gsap.fromTo(decadeModal,
                { opacity: 0, scale: 1.04 },
                {
                  opacity: 1,
                  scale: 1,
                  duration: 0.5,
                  ease: 'power2.out',
                  onComplete: () => {
                    if (modalPrevBtn) gsap.to(modalPrevBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
                    if (modalNextBtn) gsap.to(modalNextBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
                    if (decadeCloseBtn) gsap.to(decadeCloseBtn, { y: 0, opacity: 1, duration: 0.4, ease: 'back.out(1.7)' })
                    if (decadeRadialDivider) gsap.to(decadeRadialDivider, { opacity: 1, duration: 1, ease: 'power2.out' })
                  }
                }
              )
            }
          }
          shareDecadeInfo.style.display = 'block'
          gsap.fromTo(shareDecadeInfo,
            { opacity: 0 },
            { opacity: 1, duration: 0.4, ease: 'power2.out' }
          )
        }
      })
    }
  }, [], '-=0.75')

  tl.to(radialRays.slice(1), {
    opacity: 1,
    duration: radialRevealConfig.lineFadeDuration,
    ease: 'none',
    stagger: {
      each: radialRevealConfig.sweepDuration / Math.max(radialRays.length - 1, 1),
      from: 'start'
    }
  }, '-=0.75')

  // Decades appear one by one following the radial sweep order (0° → 360°)
  const sortedDecadeItems = [...exploreDecadesDecadeItems].sort((a, b) => {
    const normalise = deg => ((parseFloat(deg) - 270 + 360) % 360 + 360) % 360
    return normalise(a.dataset.angle) - normalise(b.dataset.angle)
  })
  gsap.set(sortedDecadeItems, { opacity: 0 })
  tl.set(exploreDecadesDecades, { opacity: 1 }, '-=0.9')
    .to(sortedDecadeItems, {
      opacity: 1,
      duration: 0.4,
      ease: 'power2.out',
      stagger: {
        each: radialRevealConfig.sweepDuration / sortedDecadeItems.length,
        from: 'start'
      }
    }, '-=0.75')

  // PHASE 4: Subtitle fades out → navigate prompt appears
  tl.to('.explore-decades__subtitle', {
    opacity: 0,
    duration: 0.5,
    ease: 'power2.in'
  }, '+=0.3')
    .to(exploreDecadesNavigate, {
      opacity: 1,
      duration: 0.4,
      ease: 'power2.out'
    }, '-=0.1')

  // Trigger: first click OR first scroll/touch plays the entire timeline
  let triggered = false

  const startExperience = () => {
    if (triggered) return
    triggered = true
    window.removeEventListener('wheel', startExperience)
    window.removeEventListener('touchstart', startExperience)
    if (exploreDecadesSection) {
      exploreDecadesSection.removeEventListener('click', startExperience)
    }
    tl.play()
  }

  if (isMobile()) {
    if (exploreDecadesVideo) exploreDecadesVideo.pause()
    if (exploreDecadesPrompt) gsap.set(exploreDecadesPrompt, { opacity: 0 })
    gsap.set(exploreDecadesBlue, { opacity: 1, visibility: 'visible' })
    gsap.set('.explore-decades__radial-container', { opacity: 0 })
    radialRays.forEach(ray => { ray.style.opacity = '1' })
    if (mobileLabelName) mobileLabelName.textContent = decadeData[0].label
    if (mobileLabelYear) mobileLabelYear.textContent = decadeData[0].year
    if (mobileNav) gsap.set(mobileNav, { opacity: 0 })
    if (shareNavTips) shareNavTips.style.display = 'none'

    const mobileIntroTl = gsap.timeline()

    mobileIntroTl
      .to(
        [mobileNav, '.explore-decades__radial-container'],
        {
          opacity: 1,
          duration: 0.8,
          ease: 'power2.inOut',
          onStart: () => {
            if (mobileNav) mobileNav.style.pointerEvents = 'auto'
          }
        }
      )
      .add(() => {
        rotationEnabled = true
        firstActivation = false
        activateDecade(0)
        if (shareNavTips && shareDecadeInfo && !shareInfoRevealed) {
          shareInfoRevealed = true
          shareNavTips.style.display = 'none'
          if (shareDecadeTitle) shareDecadeTitle.textContent = earlyDaysData.tagline
          if (shareDecadeDesc) shareDecadeDesc.textContent = earlyDaysData.title
          if (shareDecadeCta) {
            shareDecadeCta.onclick = () => {
              if (firstActivation) { firstActivation = false; activateDecade(0) }
              isModalOpen = true
              isEarlyDaysModal = true
              if (mobileNav) mobileNav.style.pointerEvents = 'none'
              updateModalContent(earlyDaysData)
              decadeModal.scrollTop = 0
              decadeModal.style.visibility = 'visible'
              if (modalPrevBtn) gsap.set(modalPrevBtn, { x: 80, opacity: 0 })
              if (modalNextBtn) gsap.set(modalNextBtn, { x: -80, opacity: 0 })
              if (decadeCloseBtn) gsap.set(decadeCloseBtn, { y: -30, opacity: 0 })
              if (decadeRadialDivider) gsap.set(decadeRadialDivider, { opacity: 0 })
              gsap.fromTo(decadeModal,
                { opacity: 0, scale: 1.04 },
                {
                  opacity: 1,
                  scale: 1,
                  duration: 0.5,
                  ease: 'power2.out',
                  onComplete: () => {
                    if (modalPrevBtn) gsap.to(modalPrevBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
                    if (modalNextBtn) gsap.to(modalNextBtn, { x: 0, opacity: 1, duration: 0.5, ease: 'power2.out' })
                    if (decadeCloseBtn) gsap.to(decadeCloseBtn, { y: 0, opacity: 1, duration: 0.4, ease: 'back.out(1.7)' })
                    if (decadeRadialDivider) gsap.to(decadeRadialDivider, { opacity: 1, duration: 1, ease: 'power2.out' })
                  }
                }
              )
            }
          }
          shareDecadeInfo.style.display = 'block'
          gsap.fromTo(shareDecadeInfo, { opacity: 0 }, { opacity: 1, duration: 0.4, ease: 'power2.out' })
        }
      })
  } else {
    // Desktop: trigger on first scroll / click
    window.addEventListener('wheel', startExperience, { passive: true })
    window.addEventListener('touchstart', startExperience, { passive: true })
    if (exploreDecadesSection) {
      exploreDecadesSection.addEventListener('click', startExperience)
    }
  }
})
